<template>

  <div v-if="puzzleIsInitiated">

      <Notification v-if="form.error" :notification="form.error" status="error"/>

      <div class="mb-12">
          <div class="flex">
              <FieldDate
                      class="mb-8 mr-8 md:w-1/4"
                      :fieldId="formFields.start_date.name"
                      :label="formFields.start_date.label"
                      :value="formFields.start_date.value"
                      :required="formFields.start_date.required"
                      :name="formFields.start_date.name"
                      :placeholder="formFields.start_date.placeholder"
                      :rule="formFields.start_date.rule"
                      :module="module"
                      :subform="subform"
                      :error="formFields.start_date.error"
                      :formError="form.error"
                      mask=""
              />

              <FieldTime
                      class="mb-8 md:w-1/4"
                      :fieldId="formFields.start_hour.name"
                      :label="formFields.start_hour.label"
                      :value="formFields.start_hour.value"
                      :required="formFields.start_hour.required"
                      :name="formFields.start_hour.name"
                      :placeholder="formFields.start_hour.placeholder"
                      :rule="formFields.start_hour.rule"
                      :module="module"
                      :subform="subform"
                      :error="formFields.start_hour.error"
                      :formError="form.error"
              />
          </div>

          <FieldCheckbox
                  class="mb-8"
                  :fieldId="formFields.published.name"
                  :label="formFields.published.label"
                  :value="formFields.published.value"
                  :required="formFields.published.required"
                  :name="formFields.published.name"
                  :placeholder="formFields.published.placeholder"
                  :rule="formFields.published.rule"
                  :module="module"
                  :subform="subform"
                  :error="formFields.published.error"
                  :formError="form.error"
          />
      </div>

    <button class="c-button mr-14" @click="handleSubmit">
        Opslaan
    </button>

    <button class="flex mt-18" v-if="!id" @click="generateNewPuzzle">
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 62 (91390) - https://sketch.com -->
            <title>Rectangle</title>
            <desc>Created with Sketch.</desc>
            <g id="Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Admin" transform="translate(-316.000000, -25.000000)">
                    <g id="Group-4" transform="translate(316.000000, 25.000000)">
                        <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                        <path d="M11.1730337,2 L10.111236,3.06179775 L11.9988764,4.97303371 C11.8484549,4.9641852 11.7039326,4.9494382 11.5505618,4.9494382 C7.39775281,4.9494382 4,8.34719101 4,12.5 C4,13.6325843 4.23005656,14.6855335 4.68426966,15.5910112 L5.81685393,14.458427 C5.6664324,13.8537923 5.51011236,13.1783712 5.51011236,12.5 C5.51011236,9.17893296 8.22949476,6.45955056 11.5505618,6.45955056 C11.6832863,6.45955056 11.8219101,6.47429756 11.9516854,6.48314607 L10.111236,8.34719101 L11.1730337,9.40898876 L14.358427,6.24719101 L14.8775281,5.70449438 L14.358427,5.16179775 L11.1730337,2 Z M18.4168539,9.40898876 L17.2842697,10.541573 C17.5113762,11.1462077 17.5910112,11.8216296 17.5910112,12.5 C17.5910112,15.8210678 14.8716296,18.5404494 11.5505618,18.5404494 C11.4178373,18.5404494 11.2792135,18.5257024 11.1494382,18.5168539 L12.9898876,16.652809 L11.9280899,15.5910112 L8.74269663,18.752809 L8.22359551,19.2955056 L8.74269663,19.8382022 L11.9280899,23 L12.9898876,21.9382022 L11.1022472,20.0269663 C11.2497195,20.0358148 11.4030903,20.0505618 11.5505618,20.0505618 C15.7033708,20.0505618 19.1011236,16.652809 19.1011236,12.5 C19.1011236,11.3674157 18.8710678,10.3144665 18.4168539,9.40898876 Z" id="Icon" fill="#000000"></path>
                    </g>
                </g>
            </g>
        </svg>
        <span class="font-bold ml-2">Genereer nieuwe puzzel</span>
    </button>

    <div class="mt-14">
        <div class="grid px-0">
          <div class="grid-col w-full sm:w-1/3 mb-16">
            <PuzzleGrid :isAdmin="true"/>
          </div>
          <div class="grid-col w-full sm:w-2/3 lg:w-1/2">
            <AdminPuzzleWordsForm ref="puzzleWordsForm"/>
          </div>
        </div>

        <div>
       
        </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapState, mapGetters } from 'vuex'
  import { filter, shuffle } from 'lodash'
  import { omitDeep } from '@/utils/vuexUtils'

  import {
    GENERATE_PUZZLE,
    GET_PUZZLE_BY_ID,
    CREATE_PUZZLE,
    UPDATE_PUZZLE
  } from '@/utils/graphql'

  import AdminPuzzleWordsForm from '@/modules/admin/_components/AdminPuzzleWordsForm'
  import PuzzleGrid from '@/components/puzzle/PuzzleGrid'
  import Notification from '@/components/Notification'
  import FieldCheckbox from '@/components/forms/FieldCheckbox'
  import FieldDate from '@/components/forms/FieldDate'
  import FieldTime from '@/components/forms/FieldTime'

  const PUBLICATION_SETTINGS = window.PUBLICATION_SETTINGS

  export default {
    name: 'AdminPuzzleForm',

    data () {
      return {
        module: 'admin',
        subform: 'puzzleForm',
        puzzleIsInitiated: false,
        colors: [
          '#C1E8F8',
          '#c1f8dc',
          '#c1d2f8',
          '#d4c1f8',
          '#f2c1f8',
          '#f8c1c1',
          '#f8e7c1',
          '#f8f6c1',
          '#c4f8c1',
          '#feffb4',
          // '#a1e0a0',
          // '#98a9fb',
        ]
      }
    },

    created () {
     if (!this.id) {
       this.setDefaultDate()
     }
    },

    methods: {
      async handleSubmit () {
        this.setFormError(null)
        const module = this.module
        const subform = this.subform
        const form = this.form
        const puzzleWordsForm = this.puzzleWordsForm

        this.$store.dispatch('forms/validateForm', { module, subform })
        this.$store.dispatch('forms/validateForm', { module, subform: 'puzzleWordsForm' })

        if (!form.isValid) {
          this.$SmoothScroll(this.$el, 500)
          return
        }

        if (!puzzleWordsForm.isValid) {
          this.$SmoothScroll(this.$refs.puzzleWordsForm.$el, 500)
          return
        }

        const formFields = form.fields

        let variables = omitDeep(this.currentPuzzle, ['__typename', 'color', 'placeholder', 'word_id'])
        variables.published = Boolean(formFields.published.value)
        const startDate = moment(formFields.start_date.value, moment.ISO_8601)
        const startHourParts = formFields.start_hour.value ? formFields.start_hour.value.split(':') : []
        if (startHourParts.length === 2) {
          startDate.set('hours', startHourParts[0])
          startDate.set('minutes', startHourParts[1])
        }
        variables.start_date = startDate.format('YYYY-MM-DD HH:mm:ss')

        let mutation = CREATE_PUZZLE

        if (this.id) {
          mutation = UPDATE_PUZZLE
        }

        this.$apollo.mutate({
          mutation,
          variables,
          client: 'auth'
        }).then((data) => {
          // Result
          const notification = {
            message: '✓ De puzzel is succesvol opgeslagen',
            status: 'info'
          }
          this.$store.dispatch('setSnackar', { module, notification })
          this.$router.push({ name: 'AdminDashboard' })
        }).catch((error) => {
          console.log(error)
          this.setFormError('Er liep iets mis bij het verwerken van de data')
          this.$SmoothScroll(this.$el, 500)
        })
      },

      setFormError (error) {
        const module = this.module
        const subform = this.subform
        this.$store.commit('setFormError', { module, subform, error })
      },

      setFieldValues (data) {
        const mapping = {
          start_date: data.start_date,
          published: data.published
        }

        if (mapping.start_date) {
          const startDate = moment(mapping.start_date)
          mapping.start_hour = startDate.format('HH:mm')
        }

        Object.keys(mapping).forEach((field) => {
          const value = mapping[field]
          this.$store.commit('setFieldValue', {
            module: this.module,
            subform: this.subform,
            field,
            value
          })
        })

        this.initiatePuzzle(data)
      },

      generateNewPuzzle () {
        this.$apollo.queries.generatePuzzle.refetch()
      },

      initiatePuzzle (puzzle) {
        const colors = shuffle(this.colors)

        puzzle.words = puzzle.words.map((item, index) => {
          item.color = item.is_bonus ? null : colors[index]
          return item
        })

        this.$store.dispatch('initiatePuzzle', { puzzle })
          .then(() => {
            this.puzzleIsInitiated = true
          })
      },

      resetPuzzleForm () {
        this.$store.commit('resetFields', { module: this.module, subform: 'puzzleForm' })
      },

      setDefaultDate () {
        // Set default date
        const fieldStartDate = this.formFields.start_date
        if (!fieldStartDate.value) {
          this.$store.commit('setFieldValue', {
            module: this.module,
            subform: this.subform,
            field: 'start_date',
            value: new Date()
          })
        }
        const fieldStartHour = this.formFields.start_hour
        if (!fieldStartHour.value) {
          this.$store.commit('setFieldValue', {
            module: this.module,
            subform: this.subform,
            field: 'start_hour',
            value: PUBLICATION_SETTINGS.start_hour
          })
        }
      }
    },

    apollo: {
      puzzle: {
        query () {
          return GET_PUZZLE_BY_ID
        },
        variables () {
          return {
            id: parseInt(this.id)
          }
        },
        // Variables: deep object watch
        deep: false,
        fetchPolicy: 'no-cache',
        // We use a custom update callback because
        // the field names don't match
        update: data => data.puzzle,

        result (result, key) {
          const data = result.data.puzzle
          if (!data) {
            return
          }

          this.setFieldValues(data)
        },
        skip () {
          // Only run when updating Puzzle
          return !this.id
        }
      },
      generatePuzzle: {
        query () {
          return GENERATE_PUZZLE
        },
        // Variables: deep object watch
        deep: false,
        fetchPolicy: 'no-cache',
        // We use a custom update callback because
        // the field names don't match
        update: data => data.puzzle,
        result (result) {
          this.initiatePuzzle(result.data.generate_puzzle)
        },
        skip () {
          // Only run when creating Puzzle
          return !!this.id
        }
      }
    },

    watch: {
      '$route': {
        handler: function () {
          this.resetPuzzleForm()
          this.puzzleIsInitiated = false
        },
        immediate: true
      }
    },

    computed: {
      ...mapState({
        currentPuzzle: state => state.currentPuzzle
      }),

      ...mapState('admin', {
        form: state => state.puzzleForm.form,
        formFields: state => state.puzzleForm.form.fields,
        puzzleWordsForm: state => state.puzzleWordsForm.form,
        idsToDelete: state => state.idsToDelete
      }),

      id () {
        return this.$route.params.id
      }
    },

    components: {
      PuzzleGrid,
      Notification,
      FieldCheckbox,
      FieldDate,
      FieldTime,
      AdminPuzzleWordsForm
    }
  }
</script>
